import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import VueClickAway from "vue3-click-away";
import store from "./store";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import VueCookies from "vue3-cookies";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueSmoothScroll from "vue3-smooth-scroll";
import VueElementLoading from "vue-element-loading";
import VueLazyLoad from "vue3-lazyload";
const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueClickAway);
app.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyA9Az_2wI5BBoLGDkkC8xXxO3b0pVtsGuU",
		libraries: "places",
	},
	autobindAllEvents: true,
});
app.use(VueLazyLoad);
app.use(Toast);
app.use(VueSmoothScroll, {updateHistory: false});
app.component("VueElementLoading", VueElementLoading);
app.use(VueCookies, {
	expireTimes: "1d",
	path: "/",
	domain: "",
	secure: true,
	sameSite: "None",
});
app.mount("#app");
